import { createFileRoute } from "@tanstack/react-router";
import { RecipeDetailPage } from "./-RecipeDetailPage";

export const Route = createFileRoute("/_app/_recipe-page/recipes/$recipeId")({
  component: () => <RecipeDetailPage recipeId={Route.useParams().recipeId} />,
});
